import api from "../apiConfig";
const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  index(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/subscription-price?${p}`);
  },
  create(data) {
    return api.post(`/api/v1/subscription-price`, data);
  },
  update(id, data) {
    return api.put(`/api/v1/subscription-price/${id}`, data);
  },
  // toggleActive(id) {
  //   return api.put(`/api/v1/subscription-price/${id}`);
  // },
  // activeOffersList() {
  //   return api.get(`/api/v1/subscription-price/list?for_new_customers=1`);
  // },
  // updateExpiryDate(data) {
  //   return api.put(`/api/v1/offers/assign_expiry_date/${data.id}`, {
  //     expiry_date: data.expiry_date,
  //   });
  // },
};
